<template>
 <div class="comment-section">
 	<div>
 		<h4>კითხვები</h4>
 		<button>X</button>
 	</div>
 	<add-comment></add-comment>
 	<comment-list :comments="comments"></comment-list>


 </div>
</template>

<script>
import addComment from './components/addComment'
import commentList from './components/commentList'
export default{
	components: {
		'add-comment': addComment,
		'comment-list': commentList
	},
	data(){
		return {
			comments:[],
			showAddComment: false,
		}
	},
	methods:{


	},
	mounted(){
		this.comments = [ {id:1, avatar:'https://udemy-images.udemy.com/user/50x50/13952128_73cb.jpg', title:'some it', text: 'some text'}, {id:2, avatar:'https://udemy-images.udemy.com/user/50x50/13952128_73cb.jpg', title: 'ttile dsf', text :"some 222"} ]
		window.bus.$on('commentCreated', data => {
        	this.comments.push(data)
      	})
	}
}
</script>


<style>
	.comment-section{
		    border-left: 1px solid #E8E9EB;
    		background-color: #F2F3F5;
	}
</style>
